import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/InfluencerUpdateDetailV2.graphql';
import { Query, QueryinfluencerUpdateDetailV2Args } from '../../__generated__/globalTypes';

export const useInfluencerUpdateDetailV2Query = (
  options?: QueryHookOptions<Query, QueryinfluencerUpdateDetailV2Args>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryinfluencerUpdateDetailV2Args>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useInfluencerUpdateDetailV2LazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryinfluencerUpdateDetailV2Args>
): QueryResult<Query, QueryinfluencerUpdateDetailV2Args> & {
  getInfluencerUpdateDetailV2: LazyQueryExecFunction<Query, QueryinfluencerUpdateDetailV2Args>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getInfluencerUpdateDetailV2, result] = useLazyQuery<Query, QueryinfluencerUpdateDetailV2Args>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getInfluencerUpdateDetailV2, ...result };
};

export const useInfluencerUpdateDetailV2PromiseQuery = () => {
  const client = useApolloClient();

  const getInfluencerUpdateDetailV2 = useCallback(
    (options?: Omit<QueryOptions<QueryinfluencerUpdateDetailV2Args, Query>, 'query'>) =>
      client.query<Query, QueryinfluencerUpdateDetailV2Args>({ ...options, query: QUERY }),
    [client]
  );

  return { getInfluencerUpdateDetailV2 };
};
// Suspense Query Hooks
export const useInfluencerUpdateDetailV2SuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryinfluencerUpdateDetailV2Args>
) => {
  const result = useSuspenseQuery<Query, QueryinfluencerUpdateDetailV2Args>(QUERY, {
    ...options
  });

  return result;
};
